import styled from 'styled-components';
import { getFlex } from './helpers/getFlex.js';
import { getColGutterStyle, getRowColGutterStyle } from './helpers/getGutterStyle.js';
import { getHalign } from './helpers/getHalign.js';
import { getSpacingAfter } from './helpers/getSpacingAfter.js';
import { getValign } from './helpers/getValign.js';
import { getVisibilityStyle } from './helpers/getVisibilityStyle.js';
import { getWidthStyle } from './helpers/getWidthStyle.js';

const Col = styled.div.withConfig({
    shouldForwardProp: prop => ![
        'width', 'halign', 'valign', 'spaceAfter', 'visible', 'flex', 'gutterRows', 'gutter',
    ].includes(prop),
}) `
  list-style: none;
  ${({ valign }) => typeof valign !== 'undefined' && getValign(valign)};
  ${({ halign }) => typeof halign !== 'undefined' && getHalign(halign)};
  ${({ spacingAfter }) => typeof spacingAfter !== 'undefined' && getSpacingAfter(spacingAfter)};
  ${({ gutter }) => typeof gutter !== 'undefined' && getColGutterStyle(gutter)};
  ${({ gutterRows }) => typeof gutterRows !== 'undefined' && getRowColGutterStyle(gutterRows)};
  ${({ width }) => typeof width !== 'undefined' && getWidthStyle(width)};
  ${({ visible }) => typeof visible !== 'undefined' && getVisibilityStyle(visible)};
  ${({ flex }) => flex && getFlex(flex)};
`;
Col.defaultProps = {
    width: 'stretch',
};

export { Col };
//# sourceMappingURL=Col.js.map
